import React from 'react';
import classNames from 'classnames';
import BasicImage from '@home/components/BasicImage';
import { navigate } from '@home/utils/utils';
import { IGameRankIconsProps } from './type';
import './index.scss';
import mobileGameDefaultIcon from '@/pages/dashboard/assets/svg/mobile-game-default.svg';

const RANK_LABELS = ['1st', '2nd', '3rd'];

function resolveGameRankLink(template: string, gameCode: string): string {
  return template.replace(/:gameCode/g, encodeURIComponent(gameCode));
}

const GameRankIcons: React.FC<IGameRankIconsProps> = (props) => {
  const {
    games = [],
    className = '',
    link: linkTemplate,
    // windowParams,
    // jumpType = 'window',
  } = props;

  const handleClick = (gameCode?: string) => {
    if (!gameCode || !linkTemplate) return;
    const url = resolveGameRankLink(linkTemplate, gameCode);
    //  jumpType, windowParams  先不做下钻，等产品需要再处理
    navigate(url, {});
  };

  return (
    <div className={`dbh-casual-game-rank-icons ${className}`}>
      {games.map((game, index) => {
        const hasLink = !!(game.gameCode && linkTemplate);
        const rawUrl = game?.iconUrl?.trim() ?? '';
        const src = rawUrl || mobileGameDefaultIcon;
        const itemKey = `${game.gameCode || game.name || 'game'}-${game.rank}-${index}`;
        return (
          <div
            key={itemKey}
            className={classNames('dbh-casual-game-rank-icons__item', {
              'dbh-casual-game-rank-icons__item--clickable': hasLink,
            })}
            onClick={hasLink ? () => handleClick(game?.gameCode) : undefined}
          >
            <BasicImage
              className="dbh-casual-game-rank-icons__icon"
              src={src}
              alt=""
              errorSrc={mobileGameDefaultIcon}
              loadingNode={<></>}
            />
            <span className="dbh-casual-game-rank-icons__label">
              {RANK_LABELS[game?.rank - 1] || `${game?.rank}th`}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default GameRankIcons;
